/**
 * Overview Counts sagas
 */
import { call, put, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import { httpRequest } from '../../services/http-service';
import { endPoints } from '../../services/endpoints';
import {
  fetchOverviewCounts,
  setOverviewCounts,
  setLoading,
  setError,
} from './overviewCountsSlice';
import { presentLoader, dismissLoader } from './commonSlice';

/**
 * Fetch overview counts saga
 */
function* fetchOverviewCountsSaga(): Generator<any, void, any> {
  try {
    yield put(presentLoader());
    yield put(setLoading(true));

    const response = yield call(httpRequest.get, endPoints.dashboard.overviewCounts);

    if (response?.success) {
      yield put(setOverviewCounts(response.data));
    } else {
      toast.error('Failed to fetch overview counts');
      yield put(setError('Failed to fetch overview counts'));
    }
  } catch (error: any) {
    const message = error?.message || 'Failed to fetch overview counts';
    toast.error(message);
    yield put(setError(message));
  } finally {
    yield put(setLoading(false));
    yield put(dismissLoader());
  }
}

export function* overviewCountsSagas(): Generator<any, void, any> {
  yield takeLatest(fetchOverviewCounts, fetchOverviewCountsSaga);
}

